"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-5c3cd180"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "content-wrapper" };
const _hoisted_2 = { class: "text-gray" };
const _hoisted_3 = { class: "role-template-list" };
const _hoisted_4 = {
    key: 0,
    class: "divider",
    "data-content": "選択中"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
    key: 0,
    class: "repeat-infinity-icon"
};
const _hoisted_7 = { class: "template-name-text" };
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
    key: 1,
    class: "divider",
    "data-content": "リスト"
};
const _hoisted_10 = ["onClick"];
const vue_3 = require("vue");
const Modal_vue_1 = __importDefault(require("../../vue/Modal.vue"));
const InfinityIcon_vue_1 = __importDefault(require("../../assets/icons/InfinityIcon.vue"));
const roleSectionTemplateRequest_1 = require("../../requests/roleSectionTemplateRequest");
const roles_1 = require("../../js/roles");
const roleSectionInjectionKeys_1 = require("../types/roleSectionInjectionKeys");
const common_1 = require("../../common/common");
const timeZones_1 = __importDefault(require("../../common/timeZones"));
const dateIntToKanji_1 = require("../../common/dateIntToKanji");
exports.default = (0, vue_1.defineComponent)({
    __name: 'TemplateSelectorModal',
    props: {
        selectedWeekIndex: {
            type: Number,
            required: true,
        },
        selectedCalendarDate: {
            type: String,
            required: true,
        }, // YYYY-MM-DD
        templatesInCell: {
            type: Array,
            required: true,
        },
        isWeeklyCellClicked: {
            type: Boolean,
        },
    },
    emits: ["emit-close-modal", "emit-updated-template", "emit-selected-override", "emit-remove-template-cell"],
    setup(__props, { emit: __emit }) {
        const meStore = (0, vue_3.inject)(roleSectionInjectionKeys_1.RoleViewMeStore, undefined);
        const templateStore = (0, vue_3.inject)(roleSectionInjectionKeys_1.RoleViewTemplateStore, undefined);
        const props = __props;
        const emits = __emit;
        const activeTemplateId = (0, vue_3.ref)("");
        const activeTemplateRepeat = (0, vue_3.ref)(false);
        const isVisible = (0, vue_3.ref)(true);
        const unselectedTemplates = (0, vue_3.computed)(() => {
            let out = [];
            if (templateStore?.value) {
                out = Object.keys(templateStore?.value.data).filter(t => {
                    return !selectedTemplateIds.value.includes(t);
                });
            }
            return out;
        });
        const selectedTemplateIds = (0, vue_3.computed)(() => {
            return props.templatesInCell;
        });
        const activeUserId = meStore?.getActiveUserId() || "";
        const disableOverrideBtn = (0, vue_3.computed)(() => ({ 'disabled-btn': !activeTemplateRepeat.value }));
        const modalDateTitle = (0, vue_3.computed)(() => {
            let text = `リピート (${dateIntToKanji_1.intToJapaneseWeekdayKanji[props.selectedWeekIndex]})`;
            if (props.selectedCalendarDate) {
                text = (0, common_1.jpShortDateString)(new Date(props.selectedCalendarDate), timeZones_1.default.ASIA_TOKYO);
            }
            return text;
        });
        const showDivider = (0, vue_3.computed)(() => {
            return unselectedTemplates.value.length > 0 && selectedTemplateIds.value.length > 0;
        });
        function closeModal() {
            isVisible.value = false;
            activeTemplateRepeat.value = false;
            emits('emit-close-modal');
        }
        function onCancel() {
            isVisible.value = false;
        }
        function templateById(templateId) {
            return templateStore?.value.byId(templateId);
        }
        function isRepeatTemplate(templateId) {
            return Boolean(templateById(templateId)?.isRepeatTemplate(new Date(props.selectedCalendarDate)));
        }
        function handleClickedTemplate(templateId) {
            if (activeTemplateId.value === templateId) {
                resetActiveTemplate();
            }
            else {
                setActiveTemplate(templateId);
            }
        }
        function resetActiveTemplate() {
            activeTemplateId.value = "";
            activeTemplateRepeat.value = false;
        }
        function setActiveTemplate(templateId) {
            activeTemplateId.value = templateId;
            activeTemplateRepeat.value = isRepeatTemplate(templateId);
        }
        function handleAddTemplateToCell(templateId) {
            let repeatWeekdays = [false, false, false, false, false, false, false];
            const tempRepeatDays = templateById(templateId)?.repeatedWeekDays;
            if (tempRepeatDays) {
                repeatWeekdays = [...tempRepeatDays];
            }
            if (props.isWeeklyCellClicked && props.selectedWeekIndex != -1) {
                repeatWeekdays[props.selectedWeekIndex] = true;
            }
            const data = {
                branchId: meStore?.getActiveBranchId() || "",
                repeatWeekdays,
                addDate: props.selectedCalendarDate,
            };
            updateRepeatTemplate(templateId, data);
        }
        function handleRemoveTemplateInCell(templateId) {
            const isRepeat = isRepeatTemplate(templateId);
            if (isRepeat || props.isWeeklyCellClicked) {
                handleRepeatTemplateRemoval(templateId);
            }
            else {
                confirmSingleTemplateRemoval(templateId);
            }
        }
        function handleRepeatTemplateRemoval(templateId) {
            if (props.isWeeklyCellClicked) {
                (0, roles_1.openConfirmModal)("リピートされたタイムプランを削除してもよろしいですか？", () => removeWeeklyRepeatTemplate(templateId));
            }
            else {
                confirmSingleTemplateRemoval(templateId, true);
            }
        }
        function removeWeeklyRepeatTemplate(templateId) {
            let repeatWeekdays = [false, false, false, false, false, false, false];
            const tempRepeatDays = templateById(templateId)?.repeatedWeekDays;
            if (tempRepeatDays) {
                repeatWeekdays = [...tempRepeatDays];
            }
            if (props.selectedWeekIndex != -1) {
                repeatWeekdays[props.selectedWeekIndex] = false;
            }
            const data = {
                branchId: meStore?.getActiveBranchId() || "",
                repeatWeekdays,
                skipRepeatDay: "",
            };
            updateRepeatTemplate(templateId, data);
        }
        function confirmSingleTemplateRemoval(templateId, isRepeat = false) {
            (0, roles_1.openConfirmModal)("このタイムプランを削除しますか？", () => {
                removeTemplateFromCalendarCell(templateId, isRepeat);
            });
        }
        function handleOverrideSelect() {
            emits("emit-selected-override", {
                overrideDate: props.selectedCalendarDate,
                templateId: activeTemplateId.value,
            });
        }
        async function updateRepeatTemplate(templateId, data) {
            try {
                const payload = {
                    branchId: meStore?.getActiveBranchId() || "",
                    templateId: parseInt(templateId),
                    repeatWeekdays: data.repeatWeekdays,
                    addDate: data.addDate,
                    skipRepeatDay: data.skipRepeatDay,
                };
                const updatedTemplate = await (0, roleSectionTemplateRequest_1.patchRoleSectionTemplates)(parseInt(activeUserId), payload);
                const emitData = {
                    template: updatedTemplate,
                };
                emits('emit-updated-template', emitData);
                closeModal();
            }
            catch (err) {
                console.error(err);
                (0, roles_1.openAlertModal)("Failed to update Repeat Template.");
            }
        }
        async function removeTemplateFromCalendarCell(templateId, isRepeat) {
            try {
                const payload = {
                    branchId: meStore?.getActiveBranchId() || "",
                    templateId: parseInt(templateId),
                };
                if (isRepeat) {
                    payload.skipRepeatDay = props.selectedCalendarDate;
                }
                else {
                    payload.removeDate = props.selectedCalendarDate;
                }
                const updatedTemplate = await (0, roleSectionTemplateRequest_1.patchRoleSectionTemplates)(parseInt(activeUserId), payload);
                emits('emit-remove-template-cell', {
                    template: updatedTemplate,
                    selectedDate: props.selectedCalendarDate,
                });
            }
            catch (err) {
                (0, roles_1.openAlertModal)(`Failed to remove template from cell on date: ${props.selectedCalendarDate}`);
            }
        }
        return (_ctx, _cache) => {
            return (isVisible.value)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Modal_vue_1.default, {
                    key: 0,
                    onCloseModal: closeModal,
                    onCancel: onCancel,
                    "has-title-divider": true,
                    "include-modal-footer": false
                }, {
                    "header-title": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createTextVNode)(" タイムプラン ")
                    ]),
                    content: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_1, [
                            (0, vue_2.createElementVNode)("span", _hoisted_2, (0, vue_2.toDisplayString)(modalDateTitle.value), 1 /* TEXT */),
                            (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                (0, vue_2.createCommentVNode)(" Currently in Cell "),
                                (showDivider.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_4))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(selectedTemplateIds.value, (templateId) => {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                        key: templateId,
                                        class: (0, vue_2.normalizeClass)(["role-sect-template", { 'active-template': activeTemplateId.value == templateId }]),
                                        onClick: ($event) => (handleClickedTemplate(templateId))
                                    }, [
                                        (isRepeatTemplate(templateId))
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_6, [
                                                (0, vue_2.createVNode)(InfinityIcon_vue_1.default)
                                            ]))
                                            : (0, vue_2.createCommentVNode)("v-if", true),
                                        (0, vue_2.createElementVNode)("span", _hoisted_7, (0, vue_2.toDisplayString)(templateById(templateId)?.name), 1 /* TEXT */),
                                        (0, vue_2.createElementVNode)("i", {
                                            class: "template-selector-delete-icon zmdi zmdi-close",
                                            onClick: ($event) => (handleRemoveTemplateInCell(templateId))
                                        }, null, 8 /* PROPS */, _hoisted_8)
                                    ], 10 /* CLASS, PROPS */, _hoisted_5));
                                }), 128 /* KEYED_FRAGMENT */)),
                                (0, vue_2.createCommentVNode)(" List "),
                                (unselectedTemplates.value.length && selectedTemplateIds.value.length)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_9))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(unselectedTemplates.value, (templateId) => {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                        key: templateId,
                                        class: "role-sect-template",
                                        onClick: ($event) => (handleAddTemplateToCell(templateId))
                                    }, (0, vue_2.toDisplayString)(templateById(templateId)?.name), 9 /* TEXT, PROPS */, _hoisted_10));
                                }), 128 /* KEYED_FRAGMENT */)),
                                (!__props.isWeeklyCellClicked)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                        key: 2,
                                        class: (0, vue_2.normalizeClass)(["role-sect-template override-btn", disableOverrideBtn.value]),
                                        onClick: handleOverrideSelect
                                    }, "上書き", 2 /* CLASS */))
                                    : (0, vue_2.createCommentVNode)("v-if", true)
                            ])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }))
                : (0, vue_2.createCommentVNode)("v-if", true);
        };
    }
});
